import React, { Component } from "react";
import { Modal, Row, Col, Form, Input, DatePicker, Button } from "antd";
import moment from "moment";
import PageLayout from "../../ui/PageLayout";
import http from "../../../axios/http";
import messager from "../../ui/messager";
const FormItem = Form.Item;

class AddFromVehicleForm extends Component {
  constructor(props) {  // eslint-disable-line 
    super(props);
  }
  state = {
    loadData: "",
    queryData: {
      pageNumber: 1,
      pageSize: 10,
      keyword: "",
    },
  };
  columns = [
    {
      title: "车架号",
      dataIndex: "vin",
      width: "15%",
    },
    {
      title: "车牌号",
      dataIndex: "plateNo",
      width: "10%",
    },
    {
      title: "车辆名",
      dataIndex: "name",
      width: "30%",
    },
    {
      title: "商户",
      dataIndex: "memberName",
      width: "30%",
    },
    {
      title: "选择",
      dataIndex: "id",
      render: (text, record, index) => {
        if (record.stockTake) {
          return <div>已纳入盘点</div>;
        } else {
          return (
            <div>
              <Button onClick={this.selectVehicle.bind(this, record)}>
                选择
              </Button>
            </div>
          );
        }
      },
    },
  ];
  keywordSearch = (val) => {
    let queryData = this.state.queryData;
    queryData.keyword = val;
    this.state.loadData(queryData);
  };
  selectVehicle = (info, e) => {
    this.setState({ vehicleId: info.id, vehicleInfo: info });
  };

  onDateChange = (item, val) => {
    console.log(val);
    var state = this.state;
    state.inTime = val;
    this.setState(state);
  };

  onCollectionDateChange = (item, val) => {
    this.props.editData.collectionDate = val;
  };

  onTransferDateChange = (item, val) => {
    this.props.editData.transferDate = val;
  };

  onLeaveDateChange = (item, val) => {
    this.props.editData.leaveDate = val;
  };

  save = () => {
    const { editData, form } = this.props;
    const { vehicleId, vehicleInfo } = this.state;
    if (!vehicleId) {
      messager.alert("请先选择车辆");
      return;
    }
    form.validateFields((err, values) => {
      if (err) {
        return;
      }
      if (editData.collectionDate)
        vehicleInfo["collectionDate"] = editData.collectionDate;
      else delete vehicleInfo["collectionDate"];
      if (editData.transferDate)
        vehicleInfo["transferDate"] = editData.transferDate;
      else delete vehicleInfo["transferDate"];
      if (editData.leaveDate) vehicleInfo["leaveDate"] = editData.leaveDate;
      else delete vehicleInfo["leaveDate"];
      http.post({
        url: "/vehicleStockCheck/saveVehicle",
        data: vehicleInfo,
        success: (res) => {
          messager.notify("保存成功");
          this.props.successCallback(this.props.queryData);
          this.props.onCancel();
        },
      });
    });
  };

  componentWillReceiveProps(nextProp) {
    console.log(nextProp);
    var lastVisible = this.props.visible;
    var { visible } = nextProp;
    if (visible && !lastVisible) {
      let queryData = this.state.queryData;
      queryData.keyword = "";
      queryData.pageNumber = 1;
      queryData.pageSize = 10;
      this.setState({
        queryData,
        vehicleId: "",
        vehicleInfo: {},
      });
      if (this.state.loadData) this.state.loadData(queryData);
    }
  }

  render() {
    const {  visible, onCancel } = this.props;
    return (
      <Modal
        visible={visible}
        width={1000}
        height={800}
        title={`选择商户车辆`}
        okText="新增"
        cancelText="取消"
        maskClosable={false}
        onCancel={onCancel}
        onOk={this.save}
      >
        {this.modalCotent()}
      </Modal>
    );
  }
  resetVehicle() {
    this.setState({ vehicleId: null, vehicleInfo: {} });
  }
  modalCotent() {
    const { editData, form } = this.props;
    const { getFieldDecorator } = form;
    const { vehicleId } = this.state;
    if (!vehicleId) {
      return (
        <div style={{ width: "100%", height: "500px" }}>
          <PageLayout
            condition={
              <Row>
                <Col span={6}>
                  <Input.Search
                    key={this.state.queryData.keyword}
                    defaultValue={this.state.queryData.keyword}
                    placeholder="关键字"
                    onSearch={this.keywordSearch}
                    enterButton
                  />
                </Col>
              </Row>
            }
            rowKey="id"
            url="/vehicleStockCheck/queryNotStockVehicle"
            columns={this.columns}
            initParams={{ pageNumber: 1, pageSize: 10 }}
            loadData={(func) => {
              console.log("detial props", this.props);
              this.setState({
                queryData: { pageNumber: 1, pageSize: 10 },
              });
              setTimeout(() => {
                this.setState({
                  loadData: func,
                });
              }, 1000);
            }}
          />
        </div>
      );
    } else {
      return (
        <Form
          layout="vertical"
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 15 }}
        >
          <FormItem label="车架号：">
            {this.state.vehicleInfo.vin}{" "}
            <Button onClick={this.resetVehicle.bind(this)}>选择其他</Button>
          </FormItem>
          <FormItem label="车辆名：">{this.state.vehicleInfo.name}</FormItem>
          <FormItem label="车牌号：">{this.state.vehicleInfo.plateNo}</FormItem>
          <FormItem label="商户：">
            {this.state.vehicleInfo.memberName}
          </FormItem>
          <FormItem label="过户日期：">
            {getFieldDecorator("transferDate", {
              initialValue: moment(editData.transferDate, "YYYY-MM-DD"),
            })(
              <DatePicker
                onChange={this.onTransferDateChange}
                placeholder="过户日期"
              />
            )}
          </FormItem>
          <FormItem label="收款日期：">
            {getFieldDecorator("collectionDate", {
              initialValue: moment(editData.collectionDate, "YYYY-MM-DD"),
            })(
              <DatePicker
                onChange={this.onCollectionDateChange}
                placeholder="收款日期"
              />
            )}
          </FormItem>
          <FormItem label="出库日期：">
            {getFieldDecorator("leaveDate", {
              initialValue: moment(editData.leaveDate, "YYYY-MM-DD"),
            })(
              <DatePicker
                onChange={this.onLeaveDateChange}
                placeholder="出库日期"
              />
            )}
          </FormItem>
        </Form>
      );
    }
  }
}

const AddFromVehicle = Form.create()(AddFromVehicleForm);

export default AddFromVehicle;
